import Button from "@material-ui/core/Button/Button";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import TextField from '@material-ui/core/TextField/TextField';
import Typography from "@material-ui/core/Typography/Typography";
import Save from '@material-ui/icons/Save';
import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { IAuthContextProps, withAuthContext } from "../with-auth-context";
import { ISnackbarContextProps, withSnackbar } from "../with-snackbar";
import { IContentForm } from "./icontent-form";
import { UserModel } from "../../model/autogen/UserModel";
import { UserLevel } from "../../model/autogen/UserLevel";
import { WithDefaultStyles, withDefaultStyles } from "../../utils/createStyles";
import { UsersRequestFactory } from "../../model/autogen/UsersController";
import { Iif } from "../iif";
import { SelectField } from "../utility-components";
import { Content } from "../content";
import { withEditorPage } from "../../pages/editor-page";
import DeleteIcon from "@material-ui/icons/Delete";


export interface IUserFormProps extends IContentForm<UserModel> {
}

export interface IUserState extends UserModel {
    password: string; // when creating local user accounts
    isSaving: boolean;
    isDeleting: boolean;
    level: UserLevel;
    external: boolean;
    errors: string[];
}

type UserFormComponentProps = IUserFormProps & IAuthContextProps & ISnackbarContextProps & WithDefaultStyles;

const UserLevelSelections = Object.keys(UserLevel).filter((key: any) => !isNaN(Number(UserLevel[key])) && Number(UserLevel[key]) != UserLevel.External).map(key => ({
    id: UserLevel[key],
    name: key
}));

class UserFormComponent extends React.Component<UserFormComponentProps, IUserState> {
    constructor(props: UserFormComponentProps) {
        super(props);
        console.log(UserLevel.External, props.item.level);
        this.state = {
            isSaving: false,
            isDeleting: false,
            password: '',
            ...props.item,
            external: props.item.level == UserLevel.External,
            errors: []
        };
    }
    private onSave = async () => {
        const { isSaving, ...payload } = this.state;
        const { callApi, showSnackbarMessage } = this.props;
        this.setState({ isSaving: true, errors: [] });
        try {
            const creating = !payload.userID;
            if (creating && !payload.password) {
                showSnackbarMessage('Please enter a password for the new user');
                this.setState({ isSaving: false });
                return;
            }
            const result = await callApi((fetcher) => (!creating ? UsersRequestFactory.update : UsersRequestFactory.create)(fetcher, payload));
            if (result.errors) {
                this.setState({ errors: result.errors, isSaving: false });
                showSnackbarMessage('Errors prevented us from saving this user');
                return;
            }

            showSnackbarMessage(!creating ? 'User Saved' : `New User saved (${result.documentId})`);
            this.props.onSaveCompleted();
        }
        catch (e) {
            let errors = [];
            if (e.body && e.body.errors) {
                errors = e.body.errors; showSnackbarMessage(`Error saving user`);
            }
            else {
                showSnackbarMessage(`Error saving user ${e}`);
            }
            this.setState({ isSaving: false, errors: errors });
        }
    }

    private onDelete = async () =>{
        const { isDeleting, ...payload } = this.state;
        const { callApi, showSnackbarMessage } = this.props;
        this.setState({ isDeleting: true, errors: [] });
        try {
            var updatedPayload = JSON.parse(JSON.stringify(payload));
            updatedPayload.level = UserLevel.Disabled;
            const result = await callApi((fetcher) => (UsersRequestFactory.update)(fetcher, updatedPayload));
            if (result.errors) {
                this.setState({ errors: result.errors, isDeleting: false });
                showSnackbarMessage('Errors prevented us from deleting this user');
                return;
            }

            showSnackbarMessage('User Deleted')
            this.props.onSaveCompleted();
        }
        catch (e) {
            let errors = [];
            if (e.body && e.body.errors) {
                errors = e.body.errors; showSnackbarMessage(`Error deleting user`);
            }
            else {
                showSnackbarMessage(`Error deleting user ${e}`);
            }
            this.setState({ isDeleting: false, errors: errors });
        }
    }

    private onUserLevelChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        this.setState({ [e.target.name]: e.target.value } as any);
    }
    private onUserTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ [e.target.name]: e.target.value } as any);
    }
    static readOnlyProps = { inputProps: { readOnly: true } };
    private readWriteProps = { onChange: this.onUserTextChange };

    public render(): JSX.Element {
        const { isSaving, isDeleting, errors } = this.state;
        const { item, classes } = this.props;
        const cannotChange = isSaving || isDeleting;
        // external users we can edit all details, otherwise we are read only
        const extraProps = this.state.external ? this.readWriteProps : UserFormComponent.readOnlyProps;
        const source = this.state.external ? this.state : item;

        
        const isCreatingNewUser = (this.props.item.userID === undefined || this.props.item.userID === null)

        return <div className={classes.root}>
            <Typography variant="h5">{isCreatingNewUser ? 'New User' : this.props.item.userName} Details</Typography>
            {errors && errors.map(err => <Typography className={classes.input}>{err}</Typography>)}
            <TextField className={classes.input} label="First Name" name="firstName" fullWidth={true} value={source.firstName} {...extraProps} />
            <TextField className={classes.input} label="Last Name" name="lastName" fullWidth={true} value={source.lastName} {...extraProps} />
            <TextField className={classes.input} label="Email" name="email" fullWidth={true} value={source.email} {...extraProps} />
            <Iif show={item.level != UserLevel.External} else={
                <>
                    {isCreatingNewUser && <TextField className={classes.input} label="Username" name="username" fullWidth={true} onChange={this.onUserTextChange} />}
                    <TextField className={classes.input} label="Password" name="password" type="password" fullWidth={true} onChange={this.onUserTextChange} />
                    <Typography className={classes.input}>External user</Typography>
                </>
            }>
                <SelectField className={classes.input} label="User Level" name="level" value={this.state.level} onChange={this.onUserLevelChange} fullWidth={true}>
                    {UserLevelSelections.map(a => <MenuItem key={a.id} value={a.id}>{a.name}</MenuItem>)}
                </SelectField>
            </Iif>
            <Button className={classes.input} variant="contained" fullWidth={true} onClick={this.onSave} disabled={isSaving || cannotChange} color="primary">
                {isSaving ? <CircularProgress size={24} /> : <Save />}{isSaving ? " Saving ..." : " Save"}
            </Button>
            {!isCreatingNewUser && <Button className={classes.input} variant="contained" fullWidth={true} onClick={this.onDelete} disabled={isDeleting || cannotChange} color="secondary">
                {isDeleting ? <CircularProgress size={24} /> : <DeleteIcon />}{isDeleting ? " Deleting ..." : " Delete"}
            </Button>}
        </div>;
    }
}

export class UserCreatePage extends React.Component<RouteComponentProps<any>, any> {
    constructor(props: RouteComponentProps<any>) {
        super(props);
    }
    private onSaveCompleted = () => {
        this.props.history.goBack();
    }

    render(): JSX.Element {
        return <Content>
            <UserForm item={{ level: UserLevel.External } as any} onSaveCompleted={this.onSaveCompleted} isEditing={true} />
        </Content>
    }
};

const UserFormStyled = withDefaultStyles(UserFormComponent) as React.ComponentType<IUserFormProps & IAuthContextProps & ISnackbarContextProps>;

const UserForm = withSnackbar(withAuthContext(UserFormStyled, UserLevel.Admin)) as React.ComponentType<IUserFormProps>;

export const UserEditPage = withAuthContext(withEditorPage(UserForm as any, UsersRequestFactory.getById), UserLevel.Admin);


// WEBPACK FOOTER //
// ./src/components/forms/user-form.tsx